module.exports = __webpack_public_path__ + "static/media/arch-16.32cfad9a.jpg";